import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Preloader() {
  const [visible, setVisible] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let raf;
    let start = performance.now();
    const total = 1600; // ms
    const tick = (now) => {
      const p = Math.min(100, Math.round(((now - start) / total) * 100));
      setProgress(p);
      if (p < 100) {
        raf = requestAnimationFrame(tick);
      } else {
        setTimeout(() => setVisible(false), 450);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="preloader"
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[999] flex flex-col items-center justify-center bg-[#3e2723] text-[#fbd9e5]"
          data-testid="preloader"
        >
          {/* Decorative blurred orb */}
          <motion.div
            aria-hidden
            className="absolute h-[480px] w-[480px] rounded-full bg-[#fbd9e5]/20 blur-3xl"
            animate={{ scale: [0.9, 1.1, 0.9] }}
            transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
          />

          <div className="relative flex flex-col items-center gap-10 px-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="flex flex-col items-center gap-4"
            >
              <span className="text-xs uppercase tracking-[0.4em] text-[#fbd9e5]/60">
                Social Destiny
              </span>
              <div className="overflow-hidden">
                <motion.h1
                  initial={{ y: "100%" }}
                  animate={{ y: 0 }}
                  transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
                  className="font-display text-5xl sm:text-7xl font-black tracking-tighter leading-none text-[#fbd9e5]"
                >
                  Scrie-ți destinul.
                </motion.h1>
              </div>
            </motion.div>

            <div className="flex w-64 flex-col items-center gap-3">
              <div className="h-px w-full overflow-hidden bg-[#fbd9e5]/20">
                <motion.div
                  className="h-full bg-[#fbd9e5]"
                  style={{ width: `${progress}%` }}
                  transition={{ ease: "linear" }}
                />
              </div>
              <span className="text-xs tabular-nums tracking-widest text-[#fbd9e5]/70">
                {String(progress).padStart(3, "0")}%
              </span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
